import { QueryTopAppsReportRequestParamsDto } from '../dto/top-apps/request/query-top-apps-report-request.dto';
import { CubeTimeDimensionGranularity, Weekdays } from '../enum/cube-schema.enum';
import { QueryCumulativeAverageDurationsRequestParamsDto } from '../dto/top-apps/request/query-cumulative-average-durations-request.dto';
import { TopAppsReportResult } from '../dto/top-apps/cube/mapped/top-apps-report-result.dto';
import { CumulativeAverageDurationResult } from '../dto/top-apps/cube/mapped/cumulative-avg-duration-result.dto';
import { CubeConfigDto } from '../dto/common/request/cube-config.dto';
import { AppTimeSeriesResult } from '../dto/top-apps/cube/mapped/app-time-series-result.dto';
import { QueryAppTimeSeriesRequestParamsDto } from '../dto/top-apps/request/query-app-time-series-request.dto';
import { QueryWeekdayCumulativeAverageRequestParamsDto } from '../dto/top-apps/request/query-weekday-cumulative-average-request.dto';
import { AppMetricsResult } from '../dto/top-apps/cube/mapped/app-metrics-result.dto';
import { QueryAppMetricsRequestParamsDto } from '../dto/top-apps/request/query-app-metrics-request.dto';
import { QueryUserMaxAppMetricsRequestParamsDto } from '../dto/top-apps/request/query-user-max-app-metrics-request.dto';

export interface ITopAppsReportRepository {
  queryTopAppsReport(
    params: QueryTopAppsReportRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TopAppsReportResult[]>;
  queryCumulativeAvgDurations(
    params: QueryCumulativeAverageDurationsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<CumulativeAverageDurationResult[]>;
  queryWeekdayCumulativeAvgs(
    params: QueryWeekdayCumulativeAverageRequestParamsDto,
    config: CubeConfigDto
  ): Promise<CumulativeAverageDurationResult[]>
  queryAppMetrics(
    params: QueryAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<AppMetricsResult[]>
  queryUserMaxAppMetrics(
    params: QueryUserMaxAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<AppMetricsResult>
  queryAppTimeSeries(
    params: QueryAppTimeSeriesRequestParamsDto,
    config: CubeConfigDto
  ): Promise<AppTimeSeriesResult[]>
}
